/**
 * Cookie Utility Functions
 * Shared utilities for reading and writing cookies across the site
 */

window.CookieUtils = window.CookieUtils || {
  /**
   * Get a cookie value by name
   * @param {string} name - Cookie name
   * @returns {string} Cookie value or empty string if not found
   */
  getCookie: function(name) {
    const nameKey = name + '=';
    const cookieParts = document.cookie.split(';');

    for (let i = 0; i < cookieParts.length; i++) {
      let cookie = cookieParts[i];

      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }

      if (cookie.indexOf(nameKey) === 0) {
        return cookie.substring(nameKey.length, cookie.length);
      }
    }

    return '';
  },

  /**
   * Set a cookie with name, value, and expiration
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   * @param {number} days - Number of days until expiration (default: 365)
   */
  setCookie: function(name, value, days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }
};
